import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 10px 5px;

  &:before {
    position: absolute;
    content: '';
    top: 0;
    width: 50%;
    border-top: 1px solid ${({ theme }) => theme.colours.accent};
    opacity: 50%;
  }
`;
